//
export default [
  {
    text: 'código interno',
    value: 'internal_code',
    width: '15%',
  },
  {
    text: 'nombre',
    value: 'name',
  },
  {
    text:'Stock Bodega',
    value: 'stockWarehouse',
    align:'right',
    format: 'number',
    width: '15%',
  },
  {
    text: 'stock sucursal',
    value: 'stock_total',
    align:'right',
    format: 'number',
    width: '15%',
  },
  {
    text: 'stock reservado',
    value: 'reservated',
    align:'right',
    width: '15%',
  },
  {
    text: 'cantidad',
    value: 'quantity',
    align: 'right',
    format: 'number-point',
    input: {
      reverse: true,
      type: 'float-field',
    },
    width: '15%',
  },
]
